export const AggregatableFacet = {};
export const AggregatableOperation = {
    "sum": "sum",
    "max": "max",
    "min": "min",
    "count": "count",
    "avg": "avg",
    "p99": "p99",
    "p95": "p95",
    "p90": "p90",
    "p75": "p75",
    "p50": "p50"
};
export const Facet = {
    "EntityType": "EntityType",
    "Action": "Action",
    "EventType": "EventType",
    "Actor": "Actor",
    "Team": "Team",
    "Entity": "Entity",
    "Age": "Age",
    "intervals(Age)": "intervals(Age)",
    "DayOfMonth": "DayOfMonth",
    "DayOfWeek": "DayOfWeek",
    "MonthOfYear": "MonthOfYear",
    "QuarterOfYear": "QuarterOfYear",
    "Day": "Day",
    "Week": "Week",
    "Hour": "Hour",
    "Minute": "Minute",
    "Month": "Month",
    "Quarter": "Quarter",
    "Year": "Year",
    "MinuteTrunc": "MinuteTrunc",
    "HourTrunc": "HourTrunc",
    "DayTrunc": "DayTrunc",
    "Activity": "Activity"
};
export const FacetNames = ["EntityType", "Action", "EventType", "Actor", "Team", "Entity", "Age", "intervals(Age)", "DayOfMonth", "DayOfWeek", "MonthOfYear", "QuarterOfYear", "Day", "Week", "Hour", "Minute", "Month", "Quarter", "Year", "MinuteTrunc", "HourTrunc", "DayTrunc", "Activity"];
export const unitField = 'uuid';
export const EntityTypes = [
    "Issue",
    "Project",
    "IssueComment",
    "Sprint",
    "Board",
    "Customer",
    "Repository",
    "Commit",
    "Tag",
    "Discussion",
    "DiscussionComment",
    "PullRequestReviewComment",
    "PullRequest",
    "PullRequestReview",
    "PullRequestReviewThread",
    "Branch",
    "Comment",
    "Release",
    "SourceFile",
    "CicdPipeline",
    "CicdWorkflow",
    "CalendarEntry",
    "Calendar",
    "Channel",
    "Message",
    "Team",
    "UserStatus",
    "UserCallStatus",
    "VideoCallStatus",
    "VideoCall",
    "Person",
    "Service",
    "Slo",
    "Synthetics",
    "Monitor",
    "Incident",
    "Cost",
    "CostForecast",
    "Event",
    "Flow",
    "Artifact",
    "Worklog",
    "TimeInStatus",
    "ScanTarget",
    "ScanIssue"
];
export const displayColumnInfo = {
    "CalendarEntry": [
        "startTime",
        "duration",
        "name",
        "attendeesNumber",
        "vzblKeywords",
        "vzblTopics"
    ],
    "CicdPipeline": [
        "Repository",
        "Branch",
        "Commit",
        "CreatedBy",
        "createdAt"
    ],
    "Customer": [
        "name",
        "type"
    ],
    "Issue": [
        "name",
        "summary",
        "status",
        "issueType",
        "priority",
        "CurrentAssignee"
    ],
    "IssueComment": [
        "updatedAt",
        "CreatedBy",
        "ParentName",
        "Mentions",
        "body",
        "vzblEmotion",
        "vzblTone",
        "vzblCategory",
        "vzblSentimentScore"
    ],
    "PullRequest": [
        "Branch",
        "status",
        "title",
        "commits",
        "additions",
        "deletions",
        "CreatedBy",
        "createdAt"
    ],
    "PullRequestReview": [
        "repository",
        "state",
        "PullRequest",
        "submittedAt",
        "CreatedBy"
    ],
    "PullRequestReviewComment": [
        "repository",
        "authorName",
        "pullRequestAuthorName",
        "body",
        "CreatedBy",
        "createdAt"
    ],
    "Project": [
        "projectKey",
        "name",
        "projectTypeKey",
        "integration"
    ],
    "Sprint": [
        "name",
        "state",
        "status",
        "startDate",
        "endDate",
        "goal"
    ],
    "Repository": [
        "orgName",
        "name",
        "language",
        "size",
        "description"
    ],
    "Commit": [
        "createdAt",
        "CreatedBy",
        "Repository",
        "message",
        "totalFilesModified",
        "totalFilesAdded",
        "totalFilesDeleted",
        "vzblClassifications",
        "vzblExpenseClassification"
    ],
    "Tag": [
        "Repository",
        "name",
        "status",
        "CreatedBy"
    ],
    "Branch": [
        "Repository",
        "branch",
        "status",
        "CreatedBy"
    ],
    "Comment": [
        "ParentName",
        "authorName",
        "name",
        "CreatedBy",
        "createdAt"
    ],
    "Release": [
        "Repository",
        "tagName",
        "status",
        "name",
        "body",
        "PublishedBy",
        "createdAt"
    ],
    "SourceFile": [
        "repository",
        "filename"
    ],
    "Channel": [
        "name",
        "purpose",
        "createdAt"
    ],
    "Message": [
        "createdAt",
        "ChannelName",
        "CreatedBy",
        "vzblTopics",
        "vzblCategory",
        "vzblReadTime"
    ],
    "Team": [
        "integration",
        "name",
        "teamEmailDomain"
    ],
    "Person": [
        "integration",
        "name"
    ],
    "Event": [
        "occurredAt",
        "Actor",
        "name",
        "description",
        "EntityType",
        "integration"
    ],
    "Artifact": [
        "name",
        "ecosystem",
        "version",
        "createdAt"
    ],
    "Flow": [
        "Date",
        "Person",
        "focusTime",
        "disruptedTime",
        "focusTimePercent",
        "disruptedTimePercent",
        "meetingTime",
        "videoCallTime",
        "messagingTime"
    ],
    "Worklog": [
        "Issue",
        "CreatedBy",
        "timeSpent"
    ],
    "VideoCall": [
        "Attendee",
        "name",
        "startedAt",
        "endedAt",
        "duration"
    ],
    "TimeInStatus": [
        "Parent",
        "kind",
        "status",
        "duration"
    ],
    "ScanTarget": [
        "createdAt",
        "name",
        "type",
        "origin",
        "Repository",
        "targetFile",
        "targetReference"
    ],
    "ScanIssue": [
        "createdAt",
        "name",
        "severity",
        "score",
        "status",
        "type",
        "fixable",
        "resolvedAt"
    ]
};
export const entityRelationshipSet = {
    "RelatedTo": "RelatedTo",
    "BelongsTo": "BelongsTo",
    "BelongsToMany": "BelongsToMany",
    "BelongsToFew": "BelongsToFew",
    "Organizer": "Organizer",
    "Attendee": "Attendee",
    "AssignedTo": "AssignedTo",
    "ReportedBy": "ReportedBy",
    "BelongsToStatefully": "BelongsToStatefully",
    "Mentions": "Mentions",
    "_Internal": "_Internal"
};
export const metrics = ["Flow"];
export const integrationsData = { "integrations": [{ "name": "circleci", "roles": ["cicd"], "provides": ["CicdPipeline", "Event", "Person"] }, { "name": "gcalendar", "roles": ["calendar"], "provides": ["Calendar", "CalendarEntry", "Event", "Person"] }, { "name": "jira", "roles": ["project"], "provides": ["Board", "Customer", "Event", "Issue", "IssueComment", "Person", "Project", "Sprint", "Worklog"] }, { "name": "github", "roles": ["cicd", "vcs", "project"], "provides": ["Artifact", "Branch", "CicdPipeline", "Comment", "Commit", "Discussion", "DiscussionComment", "Event", "Issue", "IssueComment", "Person", "PullRequest", "PullRequestReview", "PullRequestReviewComment", "Release", "Repository", "SourceFile", "Tag", "Team"] }, { "name": "bitbucket", "roles": ["vcs"], "provides": ["Commit", "PullRequest", "Tag"] }, { "name": "gitlab", "roles": ["vcs", "project", "cicd"], "provides": ["Artifact", "Branch", "CicdPipeline", "Commit", "Event", "Issue", "Person", "Team", "PullRequest", "PullRequestReview", "PullRequestReviewComment", "Repository", "SourceFile", "Tag"] }, { "name": "slack", "roles": ["messaging"], "provides": ["Channel", "Event", "Message", "Person", "Team", "VideoCall"] }, { "name": "snyk", "roles": ["securityScan"], "provides": ["ScanIssue", "ScanTarget"] }], "derived": { "calendar": ["Flow"], "messaging": ["Flow", "VideoCall"], "project": ["TimeInStatus"] } };
export const upwardPaths = {
    "Artifact": {
        "Repository": [
            {
                "start": "Artifact",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Branch": {
        "Issue": [
            {
                "start": "Branch",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "Repository": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Customer": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Project": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Person": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Channel": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Issue": {
        "Customer": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Project": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Sprint": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Channel": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "direct"
                    }
                ]
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "CalendarEntry": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "Commit": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "Message": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "PullRequest": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    }
                ]
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Flow": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Tag": {
        "Repository": [
            {
                "start": "Tag",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Calendar": {
        "Person": [
            {
                "start": "Calendar",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Channel": [
            {
                "start": "Calendar",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "Calendar",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "CalendarEntry": {
        "Issue": [
            {
                "start": "CalendarEntry",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "Flow": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Customer": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Project": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Person": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Channel": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "CicdWorkflow": {
        "CicdPipeline": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Commit": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Branch": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Person": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Project": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Sprint": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Channel": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Team": [
            {
                "start": "CicdWorkflow",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ]
    },
    "Channel": {
        "Team": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Commit": {
        "Branch": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Issue": [
            {
                "start": "Commit",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ]
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Person": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "CicdPipeline": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Customer": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Project": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Sprint": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Channel": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Comment": {
        "Commit": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Repository": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Person": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Customer": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Project": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Sprint": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 5
            },
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Channel": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "CicdPipeline": {
        "Commit": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Repository": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Branch": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "PullRequest": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Person": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Customer": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Project": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Sprint": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Channel": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "Mentions",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Discussion": {
        "Repository": [
            {
                "start": "Discussion",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "DiscussionComment": {
        "Discussion": [
            {
                "start": "DiscussionComment",
                "hops": [
                    {
                        "tail": "Discussion",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Repository": [
            {
                "start": "DiscussionComment",
                "hops": [
                    {
                        "tail": "Discussion",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Flow": {
        "Person": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Channel": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "PullRequest": {
        "Branch": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Repository": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "PullRequest",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ]
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Customer": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Project": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Person": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Sprint": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Channel": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Team": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ]
    },
    "Message": {
        "Flow": [
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Channel": [
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Message",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ]
            }
        ],
        "Team": [
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Project": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "IssueComment": {
        "Issue": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Branch": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CalendarEntry": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Project": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Channel": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Flow": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Person": {
        "Channel": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Team": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "PullRequestReview": {
        "PullRequest": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Project": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Person": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Sprint": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Channel": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Team": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ]
    },
    "PullRequestReviewComment": {
        "PullRequest": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Project": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Person": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Sprint": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "Channel": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Team": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ]
    },
    "Release": {
        "Repository": [
            {
                "start": "Release",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "ScanIssue": {
        "ScanTarget": [
            {
                "start": "ScanIssue",
                "hops": [
                    {
                        "tail": "ScanTarget",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Repository": [
            {
                "start": "ScanIssue",
                "hops": [
                    {
                        "tail": "ScanTarget",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "ScanTarget": {
        "Repository": [
            {
                "start": "ScanTarget",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ]
    },
    "UserCallStatus": {
        "Person": [
            {
                "start": "UserCallStatus",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Channel": [
            {
                "start": "UserCallStatus",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "UserCallStatus",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ]
    },
    "TimeInStatus": {
        "Issue": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CalendarEntry": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Project": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Person": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Flow": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Channel": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "TimeInStatus",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "VideoCall": {
        "Flow": [
            {
                "start": "VideoCall",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "VideoCall",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Channel": [
            {
                "start": "VideoCall",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "VideoCall",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Worklog": {
        "Issue": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CalendarEntry": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Customer": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Project": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Repository": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Person": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Sprint": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Flow": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Channel": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsToFew",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Team": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Event": {
        "Artifact": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Artifact",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Board": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Board",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ],
        "CalendarEntry": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "CicdPipeline": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Comment": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Commit": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Message": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "UserCallStatus",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequestReview": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Release": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Release",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Repository": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Repository",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Artifact",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Release",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Tag",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Repository",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 5
            }
        ],
        "Sprint": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Sprint",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Sprint",
                        "rel": "BelongsToStatefully",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Tag": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Tag",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "UserCallStatus": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "UserCallStatus",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "UserStatus": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "UserStatus",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "VideoCall": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Worklog": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Flow": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Customer": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Customer",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Project": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Project",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            }
        ],
        "Channel": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            }
        ],
        "Team": [
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 2
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "UserCallStatus",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 3
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            },
            {
                "start": "Event",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "Entity",
                        "dir": "direct"
                    },
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Person",
                        "rel": "AssignedTo",
                        "dir": "direct"
                    },
                    {
                        "tail": "Team",
                        "rel": "BelongsTo",
                        "dir": "direct"
                    }
                ],
                "total": 4
            }
        ]
    }
};
export const downwardPaths = {
    "Repository": {
        "Artifact": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Artifact",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Tag": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Tag",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Commit": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "CicdPipeline": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Discussion": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Discussion",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Issue": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "PullRequest": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Release": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Release",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "ScanTarget": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "ScanTarget",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Artifact",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Tag",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Release",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "Comment": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "SourceFile": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "DiscussionComment": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Discussion",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "DiscussionComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CalendarEntry": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequestReview": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "Branch",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "ScanIssue": [
            {
                "start": "Repository",
                "hops": [
                    {
                        "tail": "ScanTarget",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "ScanIssue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Issue": {
        "Branch": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ]
            }
        ],
        "CalendarEntry": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "back"
                    }
                ]
            }
        ],
        "Commit": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    }
                ]
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ]
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "Issue",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "back"
                    }
                ]
            }
        ],
        "IssueComment": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "TimeInStatus": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Worklog": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Comment": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "SourceFile": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequestReview": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Issue",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ]
    },
    "Branch": {
        "Commit": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "CicdPipeline": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Comment": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "SourceFile": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequestReview": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Branch",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ]
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "IssueComment": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "TimeInStatus": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "Branch",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Branch",
                "hops": [
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ]
    },
    "PullRequest": {
        "Commit": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "CicdPipeline": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Comment": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "SourceFile": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequestReview": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "CicdWorkflow": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "PullRequest",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ]
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "TimeInStatus": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "PullRequest",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Commit": {
        "CicdPipeline": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Comment": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "SourceFile": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Commit",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ]
            }
        ],
        "Event": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Commit",
                "hops": [
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Commit",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Person": {
        "Calendar": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Calendar",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Flow": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "UserCallStatus": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "UserCallStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Commit": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "IssueComment": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Message": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "UserCallStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CalendarEntry": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "VideoCall": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Comment": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "SourceFile": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Branch": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "PullRequest": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "TimeInStatus": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequestReview": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Person",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ]
    },
    "Flow": {
        "CalendarEntry": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Message": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "VideoCall": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Issue": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "TimeInStatus": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Flow",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Customer": {
        "CalendarEntry": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Issue": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Branch": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Message": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "Comment": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "SourceFile": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReview": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Customer",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ]
    },
    "CicdPipeline": {
        "CicdWorkflow": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "CicdPipeline",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Team": {
        "Channel": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Person": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Message": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Calendar": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Calendar",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Flow": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "UserCallStatus": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "UserCallStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Channel",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "UserCallStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "CalendarEntry": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "VideoCall": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Comment": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "SourceFile": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Branch": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "TimeInStatus": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReview": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Team",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ]
    },
    "Discussion": {
        "DiscussionComment": [
            {
                "start": "Discussion",
                "hops": [
                    {
                        "tail": "DiscussionComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "CalendarEntry": {
        "Issue": [
            {
                "start": "CalendarEntry",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ]
            }
        ],
        "Event": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "IssueComment": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "CalendarEntry",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Message": {
        "Issue": [
            {
                "start": "Message",
                "total": 1,
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ]
            }
        ],
        "Event": [
            {
                "start": "Message",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "IssueComment": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Message",
                "hops": [
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ]
    },
    "Project": {
        "Issue": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Branch": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CalendarEntry": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Message": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "Comment": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "SourceFile": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReview": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Project",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ]
    },
    "Sprint": {
        "Issue": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Event": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Branch": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CalendarEntry": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "CalendarEntry",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Message": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Message",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "TimeInStatus": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Worklog": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "Comment": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "SourceFile": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 5
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReview": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Commit",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Sprint",
                "hops": [
                    {
                        "tail": "Issue",
                        "rel": "BelongsToStatefully",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ]
    },
    "Channel": {
        "Person": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Message": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ],
        "Calendar": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Calendar",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Flow": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "UserCallStatus": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "UserCallStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Commit": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "IssueComment": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Issue": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Message",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CalendarEntry": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CalendarEntry",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "VideoCall": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Flow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "VideoCall",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Comment": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdPipeline": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "SourceFile": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "SourceFile",
                        "rel": "BelongsToMany",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Branch": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "PullRequest": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "TimeInStatus": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdWorkflow": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Commit",
                        "rel": "Mentions",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            }
        ],
        "PullRequestReview": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReview",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ],
        "PullRequestReviewComment": [
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "PullRequest",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 4
            },
            {
                "start": "Channel",
                "hops": [
                    {
                        "tail": "Person",
                        "rel": "BelongsToFew",
                        "dir": "back"
                    },
                    {
                        "tail": "Issue",
                        "rel": "AssignedTo",
                        "dir": "back"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Branch",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequest",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "PullRequestReviewComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 5
            }
        ]
    },
    "ScanTarget": {
        "ScanIssue": [
            {
                "start": "ScanTarget",
                "hops": [
                    {
                        "tail": "ScanIssue",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "SourceFile": {
        "Commit": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    }
                ],
                "total": 1
            }
        ],
        "Comment": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "CicdPipeline": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Issue": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    }
                ],
                "total": 2
            }
        ],
        "Event": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 2
            },
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "Comment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            },
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "CicdWorkflow": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "tail": "CicdPipeline",
                        "rel": "BelongsTo",
                        "dir": "back"
                    },
                    {
                        "tail": "CicdWorkflow",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "IssueComment": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "IssueComment",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "TimeInStatus": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "TimeInStatus",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ],
        "Worklog": [
            {
                "start": "SourceFile",
                "hops": [
                    {
                        "tail": "Commit",
                        "rel": "BelongsToMany",
                        "dir": "direct"
                    },
                    {
                        "rel": "RelatedTo",
                        "tail": "Issue",
                        "dir": "back"
                    },
                    {
                        "tail": "Worklog",
                        "rel": "BelongsTo",
                        "dir": "back"
                    }
                ],
                "total": 3
            }
        ]
    },
    "Artifact": {
        "Event": [
            {
                "start": "Artifact",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Board": {
        "Event": [
            {
                "start": "Board",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Comment": {
        "Event": [
            {
                "start": "Comment",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "IssueComment": {
        "Event": [
            {
                "start": "IssueComment",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "PullRequestReview": {
        "Event": [
            {
                "start": "PullRequestReview",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "PullRequestReviewComment": {
        "Event": [
            {
                "start": "PullRequestReviewComment",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Release": {
        "Event": [
            {
                "start": "Release",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Tag": {
        "Event": [
            {
                "start": "Tag",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "UserCallStatus": {
        "Event": [
            {
                "start": "UserCallStatus",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "UserStatus": {
        "Event": [
            {
                "start": "UserStatus",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "VideoCall": {
        "Event": [
            {
                "start": "VideoCall",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    },
    "Worklog": {
        "Event": [
            {
                "start": "Worklog",
                "hops": [
                    {
                        "tail": "Event",
                        "rel": "Entity",
                        "dir": "back"
                    }
                ],
                "total": 1
            }
        ]
    }
};
export const setSchema = {
    "Artifact": {
        "Repository": "BelongsTo"
    },
    "Branch": {
        "Issue": "RelatedTo",
        "Repository": "BelongsTo"
    },
    "Tag": {
        "Repository": "BelongsTo"
    },
    "Calendar": {
        "Person": "BelongsTo"
    },
    "CalendarEntry": {
        "Issue": "RelatedTo",
        "Flow": "BelongsTo",
        "Customer": "BelongsTo"
    },
    "CicdWorkflow": {
        "CicdPipeline": "BelongsTo"
    },
    "Channel": {
        "Team": "BelongsTo"
    },
    "Commit": {
        "Branch": "BelongsToFew",
        "Issue": "RelatedTo",
        "PullRequest": "BelongsToFew",
        "Repository": "BelongsTo",
        "Person": "Mentions"
    },
    "Comment": {
        "Commit": "BelongsTo"
    },
    "CicdPipeline": {
        "Commit": "BelongsTo",
        "Repository": "BelongsTo",
        "Branch": "BelongsTo"
    },
    "Discussion": {
        "Repository": "BelongsTo"
    },
    "DiscussionComment": {
        "Discussion": "BelongsTo"
    },
    "Flow": {
        "Person": "BelongsTo"
    },
    "Issue": {
        "Branch": "RelatedTo",
        "CalendarEntry": "RelatedTo",
        "Commit": "RelatedTo",
        "Customer": "BelongsTo",
        "Issue": "BelongsToStatefully",
        "Message": "RelatedTo",
        "Person": "AssignedTo",
        "Project": "BelongsTo",
        "PullRequest": "RelatedTo",
        "Sprint": "BelongsToStatefully",
        "Repository": "BelongsTo"
    },
    "IssueComment": {
        "Issue": "BelongsTo",
        "Person": "Mentions"
    },
    "Person": {
        "CalendarEntry": "Attendee",
        "Channel": "BelongsToFew",
        "Person": "RelatedTo",
        "Team": "BelongsTo",
        "VideoCall": "Attendee"
    },
    "PullRequest": {
        "Branch": "BelongsTo",
        "Issue": "RelatedTo",
        "Repository": "BelongsTo"
    },
    "PullRequestReview": {
        "PullRequest": "BelongsTo"
    },
    "PullRequestReviewComment": {
        "PullRequest": "BelongsTo"
    },
    "Release": {
        "Repository": "BelongsTo"
    },
    "ScanIssue": {
        "ScanTarget": "BelongsTo"
    },
    "ScanTarget": {
        "Repository": "BelongsTo"
    },
    "SourceFile": {
        "Commit": "BelongsToMany"
    },
    "UserCallStatus": {
        "Person": "BelongsTo"
    },
    "Message": {
        "Channel": "BelongsTo",
        "Person": "Mentions",
        "Issue": "RelatedTo",
        "Flow": "BelongsTo"
    },
    "TimeInStatus": {
        "Issue": "BelongsTo"
    },
    "VideoCall": {
        "Flow": "BelongsTo"
    },
    "Worklog": {
        "Issue": "BelongsTo"
    }
};
export const actSchema = {
    "Person": {
        "Artifact": {
            "Created": "Created"
        },
        "Branch": {
            "Created": "Created",
            "Deleted": "Deleted"
        },
        "Tag": {
            "Created": "Created",
            "Deleted": "Deleted"
        },
        "CicdPipeline": {
            "Created": "Created",
            "Updated": "Updated"
        },
        "Comment": {
            "Created": "Created"
        },
        "Commit": {
            "Created": "Created"
        },
        "Discussion": {
            "Answered": "Answered",
            "Created": "Created",
            "Deleted": "Deleted",
            "Updated": "Updated"
        },
        "DiscussionComment": {
            "Created": "Created",
            "Deleted": "Deleted",
            "Updated": "Updated"
        },
        "Issue": {
            "Created": "Created",
            "Updated": "Updated",
            "Deleted": "Deleted"
        },
        "IssueComment": {
            "Created": "Created",
            "Deleted": "Deleted",
            "Updated": "Updated"
        },
        "Message": {
            "Created": "Created"
        },
        "PullRequest": {
            "Created": "Created",
            "Merged": "Merged",
            "Closed": "Closed",
            "Opened": "Opened",
            "Updated": "Updated"
        },
        "PullRequestReview": {
            "Closed": "Closed",
            "Created": "Created",
            "Updated": "Updated"
        },
        "PullRequestReviewComment": {
            "Created": "Created"
        },
        "PullRequestReviewThread": {
            "Closed": "Closed",
            "Opened": "Opened"
        },
        "Release": {
            "Created": "Created",
            "Published": "Published"
        },
        "Repository": {
            "Created": "Created"
        },
        "SourceFile": {
            "Created": "Created",
            "Updated": "Updated",
            "Deleted": "Deleted"
        },
        "Worklog": {
            "Created": "Created"
        }
    },
    "Branch": {
        "Branch": {
            "MergedTo": "MergedTo"
        }
    }
};
export const entityFacets = {
    "Artifact": {
        "CreatedBy": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Artifact",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Artifact",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Artifact",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Board": {
        "ActivityDayOfMonth": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Board",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Board",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Board",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Branch": {
        "Repository": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "MergedTo": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Branch",
                    "rel": "MergedTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Branch",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Branch",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Branch",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Calendar": {
        "ActivityTeam": {
            "start": "Calendar",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Calendar",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Calendar",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Calendar",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Calendar",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "CalendarEntry": {
        "Attendees": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Attendee",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "CalendarEntry",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "CalendarEntry",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "CalendarEntry",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Channel": {
        "Team": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Channel",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Channel",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Channel",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "CicdPipeline": {
        "Repository": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Commit": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Commit",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Branch": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Branch",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "CicdPipeline",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "CicdPipeline",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "CicdPipeline",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Comment": {
        "ParentName": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Commit",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Comment",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Comment",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Comment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Commit": {
        "Repository": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Commit",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Commit",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Commit",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Event": {
        "EntityType": {
            "start": "Event",
            "total": 1,
            "hops": [
                {
                    "rel": "Entity",
                    "dir": "direct"
                }
            ]
        },
        "Actor": {
            "start": "Event",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Team": {
            "start": "Event",
            "total": 2,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Entity": {
            "start": "Event",
            "total": 1,
            "hops": [
                {
                    "rel": "Entity",
                    "dir": "direct"
                }
            ]
        }
    },
    "Discussion": {
        "ActivityTeam": {
            "start": "Discussion",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Discussion",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Discussion",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Discussion",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Discussion",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "DiscussionComment": {
        "ActivityTeam": {
            "start": "DiscussionComment",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "DiscussionComment",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "DiscussionComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "DiscussionComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "DiscussionComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Flow": {
        "Person": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Team": {
            "start": "Flow",
            "total": 2,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Messages": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Message",
                    "dir": "direct"
                }
            ]
        },
        "CalendarEntries": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "CalendarEntry",
                    "dir": "direct"
                }
            ]
        },
        "VideoCalls": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "VideoCall",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Flow",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Flow",
            "total": 2,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        }
    },
    "Issue": {
        "Epic": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Issue",
                    "dir": "direct"
                }
            ]
        },
        "CurrentAssignee": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "AssignedTo",
                    "dir": "direct"
                }
            ]
        },
        "CurrentAssignee.Team": {
            "start": "Issue",
            "total": 2,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "AssignedTo",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CurrentReporter": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "ReportedBy",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "Assignees": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "WasAssignedTo",
                    "dir": "direct"
                }
            ]
        },
        "Assignees.Team": {
            "start": "Issue",
            "total": 2,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "WasAssignedTo",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Mentions": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Mentions",
                    "dir": "direct"
                }
            ]
        },
        "Reporters": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "WasReportedBy",
                    "dir": "direct"
                }
            ]
        },
        "CurrentSprints": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Sprint",
                    "rel": "BelongsToStatefully",
                    "dir": "direct"
                }
            ]
        },
        "Sprints": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Sprint",
                    "rel": "DidBelongTo",
                    "dir": "direct"
                }
            ]
        },
        "ParentIssue": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsToStatefully",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Issue",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Issue",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Issue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "IssueComment": {
        "ParentName": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "Mentions": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Mentions",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "IssueComment",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "IssueComment",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "IssueComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Message": {
        "ChannelName": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Channel",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "TeamName": {
            "start": "Message",
            "total": 2,
            "hops": [
                {
                    "tail": "Channel",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "Mentions": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Mentions",
                    "dir": "direct"
                }
            ]
        },
        "Readers": {
            "start": "Message",
            "total": 2,
            "hops": [
                {
                    "tail": "Channel",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Person",
                    "rel": "BelongsToFew",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Message",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Message",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Message",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Person": {
        "Team": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Person",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Person",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Person",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Project": {
        "ActivityDayOfMonth": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Project",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Project",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Project",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "PullRequest": {
        "Repository": {
            "start": "PullRequest",
            "total": 2,
            "hops": [
                {
                    "tail": "Branch",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "Branch": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Branch",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "PullRequest",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "PullRequest",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "PullRequest",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "PullRequestReview": {
        "PullRequest": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "PullRequest",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "PullRequestCreatedAt": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "PullRequest",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "PullRequestMergedAt": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "PullRequest",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "PullRequestReview",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "PullRequestReview",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "PullRequestReview",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "PullRequestReviewComment": {
        "PullRequest": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "PullRequest",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "PullRequestReviewComment",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "PullRequestReviewComment",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "PullRequestReviewComment",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Release": {
        "Repository": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "PublishedBy": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Published",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Release",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Release",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Release",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Repository": {
        "ActivityDayOfMonth": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Repository",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Repository",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Repository",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "ScanTarget": {
        "Repository": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "ScanTarget",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "ScanTarget",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "ScanTarget",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "ScanIssue": {
        "Repository": {
            "start": "ScanIssue",
            "total": 2,
            "hops": [
                {
                    "tail": "ScanTarget",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ScanTarget": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "ScanTarget",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "ScanIssue",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "ScanIssue",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "ScanIssue",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "SourceFile": {
        "ActivityDayOfMonth": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "SourceFile",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "SourceFile",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "SourceFile",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Sprint": {
        "ActivityDayOfMonth": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Sprint",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Sprint",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Sprint",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Tag": {
        "Repository": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Repository",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "CreatedBy": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Tag",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Tag",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Tag",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Team": {
        "ActivityDayOfMonth": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Team",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Team",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Team",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "TimeInStatus": {
        "Parent": {
            "start": "TimeInStatus",
            "total": 1,
            "hops": [
                {
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityTeam": {
            "start": "TimeInStatus",
            "total": 4,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "TimeInStatus",
            "total": 3,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "TimeInStatus",
            "total": 2,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "TimeInStatus",
            "total": 2,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "TimeInStatus",
            "total": 2,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                },
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "VideoCall": {
        "Attendee": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Attendee",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "VideoCall",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "VideoCall",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "VideoCall",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    },
    "Worklog": {
        "CreatedBy": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Person",
                    "rel": "Created",
                    "dir": "back"
                }
            ]
        },
        "Issue": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Issue",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityDayOfMonth": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayOfWeek": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonthOfYear": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarterOfYear": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDay": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityWeek": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHour": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinute": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMonth": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityQuarter": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityYear": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityMinuteTrunc": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityHourTrunc": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityDayTrunc": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityTeam": {
            "start": "Worklog",
            "total": 3,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                },
                {
                    "tail": "Team",
                    "rel": "BelongsTo",
                    "dir": "direct"
                }
            ]
        },
        "ActivityActor": {
            "start": "Worklog",
            "total": 2,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                },
                {
                    "tail": "Person",
                    "rel": "Actor",
                    "dir": "direct"
                }
            ]
        },
        "Activity": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAction": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        },
        "ActivityAt": {
            "start": "Worklog",
            "total": 1,
            "hops": [
                {
                    "tail": "Event",
                    "rel": "Entity",
                    "dir": "back"
                }
            ]
        }
    }
};
export const structuredFacetSchemas = {
    "Issue": {
        "CurrentReporter": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "CurrentAssignee": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "CurrentAssignee.Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "CurrentSprints": {
            "type": "Sprint",
            "attributes": [
                "uuid",
                "status",
                "name"
            ]
        },
        "Sprints": {
            "type": "Sprint",
            "attributes": [
                "uuid",
                "status",
                "name"
            ]
        },
        "Assignees": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Assignees.Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Mentions": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Reporters": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "ParentIssue": {
            "type": "Issue",
            "attributes": [
                "uuid",
                "status",
                "name"
            ]
        },
        "Epic": {
            "type": "Issue",
            "attributes": [
                "uuid",
                "status",
                "title",
                "statusCategory",
                "statusLabel",
                "issueKey",
                "dueDate",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Project": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "IssueComment": {
        "ParentName": {
            "type": "Issue",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Mentions": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Sprint": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Board": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Repository": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Commit": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Tag": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Discussion": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "DiscussionComment": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "PullRequestReviewComment": {
        "PullRequest": {
            "type": "PullRequest",
            "attributes": [
                "uuid",
                "title"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "PullRequest": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Branch": {
            "type": "Branch",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "PullRequestReview": {
        "PullRequest": {
            "type": "PullRequest",
            "attributes": [
                "uuid",
                "title"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "PullRequestReviewThread": {},
    "Branch": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "MergedTo": {
            "type": "Branch",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Comment": {
        "ParentName": {
            "type": "Commit",
            "attributes": [
                "uuid",
                "message"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Release": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "PublishedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "SourceFile": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "CicdPipeline": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Commit": {
            "type": "Commit",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Branch": {
            "type": "Branch",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "CicdWorkflow": {},
    "CalendarEntry": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Calendar": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Channel": {
        "Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Customer": {},
    "Message": {
        "ChannelName": {
            "type": "Channel",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "TeamName": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Mentions": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Readers": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Team": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "UserStatus": {},
    "UserCallStatus": {},
    "VideoCallStatus": {},
    "VideoCall": {
        "Attendee": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Person": {
        "Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Service": {},
    "Slo": {},
    "Synthetics": {},
    "Monitor": {},
    "Incident": {},
    "Cost": {},
    "CostForecast": {},
    "Event": {
        "Actor": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "isBot",
                "name"
            ]
        },
        "Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Entity": {
            "attributes": [
                "name",
                "uuid",
                "uuid"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "Age",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Flow": {
        "Person": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Team": {
            "type": "Team",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Messages": {
            "type": "Message",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "CalendarEntries": {
            "type": "CalendarEntry",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "VideoCalls": {
            "type": "VideoCall",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Flow",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "Age",
                "occurredAt",
                "uuid",
                "occurredAt"
            ]
        }
    },
    "Artifact": {
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "TimeInStatus": {
        "Parent": {
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "Worklog": {
        "CreatedBy": {
            "type": "Person",
            "attributes": [
                "avatarUrl",
                "uuid",
                "name"
            ]
        },
        "Issue": {
            "type": "Issue",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "ScanTarget": {
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    },
    "ScanIssue": {
        "ScanTarget": {
            "type": "ScanTarget",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Repository": {
            "type": "Repository",
            "attributes": [
                "uuid",
                "name"
            ]
        },
        "Activity": {
            "type": "Event",
            "attributes": [
                "DayOfMonth",
                "DayOfWeek",
                "MonthOfYear",
                "QuarterOfYear",
                "Day",
                "Week",
                "Hour",
                "Minute",
                "Month",
                "Quarter",
                "Year",
                "MinuteTrunc",
                "HourTrunc",
                "DayTrunc",
                "Action",
                "Actor",
                "Team",
                "occurredAt",
                "uuid",
                "name"
            ]
        }
    }
};
export const formulaFunctions = [
    {
        "id": "+",
        "description": "addition",
        "operator": true,
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                }
            }
        ]
    },
    {
        "id": "*",
        "description": "multiplication",
        "operator": true,
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                },
                "serializedReturnUnit": "(a, b) => {\n        const units = [a, b].map((p) => p.unit).filter((p) => p);\n        return units.length < 2\n            ? units.at(0)\n            : units.map((p) => `(${p})`).join(\"*\");\n    }"
            }
        ]
    },
    {
        "id": "/",
        "description": "division. returns Infinity when dividing by zero",
        "operator": true,
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                },
                "serializedReturnUnit": "(a, b) => a.unit\n        ? b.unit\n            ? `(${a.unit})/(${b.unit})`\n            : a.unit\n        : b.unit\n            ? `1/(${b.unit})`\n            : undefined"
            }
        ]
    },
    {
        "id": "abs",
        "description": "absolute value",
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                }
            }
        ]
    },
    {
        "id": "ceil",
        "description": "floor: round down to the nearest integer",
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                }
            }
        ]
    },
    {
        "id": "dayTrunc",
        "description": "truncate date to the nearest preceding day",
        "signature": [
            {
                "input": [
                    {
                        "type": "datetime"
                    }
                ],
                "return": {
                    "type": "datetime"
                }
            }
        ]
    },
    {
        "id": "minuteTrunc",
        "description": "truncate date to the nearest preceding minute",
        "signature": [
            {
                "input": [
                    {
                        "type": "datetime"
                    }
                ],
                "return": {
                    "type": "datetime"
                }
            }
        ]
    },
    {
        "id": "hourTrunc",
        "description": "truncate date to the nearest preceding hour",
        "signature": [
            {
                "input": [
                    {
                        "type": "datetime"
                    }
                ],
                "return": {
                    "type": "datetime"
                }
            }
        ]
    },
    {
        "id": "timePeriod",
        "description": "the interval between the query start and end dates",
        "signature": [
            {
                "input": [],
                "return": {
                    "type": "number",
                    "unit": "second"
                }
            }
        ]
    },
    {
        "id": "workTimePeriod",
        "description": "the interval between the query start and end dates, excluding week-ends",
        "signature": [
            {
                "input": [],
                "return": {
                    "type": "number",
                    "unit": "second"
                }
            }
        ]
    },
    {
        "id": "workTimeHours",
        "description": "working hours between start and end dates",
        "signature": [
            {
                "input": [],
                "return": {
                    "type": "number",
                    "unit": "second"
                }
            }
        ]
    },
    {
        "id": "-",
        "description": "difference (when applied to dates, returns the duration between dates)",
        "operator": true,
        "signature": [
            {
                "input": [
                    {
                        "type": "number"
                    },
                    {
                        "type": "number"
                    }
                ],
                "return": {
                    "type": "number"
                }
            },
            {
                "input": [
                    {
                        "type": "datetime"
                    },
                    {
                        "type": "datetime"
                    }
                ],
                "return": {
                    "type": "number",
                    "unit": "second"
                }
            }
        ]
    },
    {
        "id": "now",
        "description": "the current date and time",
        "signature": [
            {
                "input": [],
                "return": {
                    "type": "datetime"
                }
            }
        ]
    }
];
export const systemFieldsData = { "identifier": { "type": "string" }, "observedAt": { "type": "datetime" }, "firstObservedAt": { "type": "datetime" }, "orgId": { "type": "string" }, "recordedAt": { "type": "datetime" }, "sourceId": { "type": "string" }, "uuid": { "type": "string" }, "_streamItemId": { "type": "string" }, "_mergeOrder": { "type": "number" }, "_lexicographicMergeOrder": { "type": "string" }, "synthetic": { "type": "boolean" }, "_payloadUuid": { "type": "string" }, "_postEnriched": { "type": "datetime" }, "_postProcessed": { "type": "datetime" } };
export const orderedTimeDimensionFields = { "MinuteTrunc": "minute", "HourTrunc": "hour", "DayTrunc": "day", "Day": "day", "Week": "week", "Month": "month", "Quarter": "quarter", "Year": "year" };
export const entityDefinitions = {
    "Activity": {
        "description": "Events on the current entity",
        "exampleFields": [
            "Actor",
            "occurredAt",
            "Action",
            "Actor"
        ]
    },
    "Artifact": {
        "description": "A CI/CD build output",
        "exampleFields": [
            "kind",
            "version",
            "registry",
            "ecosystem",
            "createdAt"
        ]
    },
    "Board": {
        "description": "A project management board",
        "exampleFields": [
            "type",
            "status"
        ]
    },
    "Branch": {
        "description": "A version control branch",
        "exampleFields": [
            "repository",
            "createdAt",
            "CreatedBy",
            "MergedTo"
        ]
    },
    "Calendar": {
        "description": "A calendar",
        "exampleFields": [
            "name",
            "owner",
            "timezone"
        ]
    },
    "CalendarEntry": {
        "description": "A calendar event",
        "exampleFields": [
            "summary",
            "startTime",
            "endTime",
            "attendeesNumber",
            "duration"
        ]
    },
    "Channel": {
        "description": "A messaging channel",
        "exampleFields": [
            "name",
            "purpose",
            "createdAt",
            "memberCount"
        ]
    },
    "CicdPipeline": {
        "description": "A CI/CD pipeline",
        "exampleFields": [
            "branch",
            "state",
            "createdAt",
            "Commit",
            "CreatedBy"
        ]
    },
    "CicdWorkflow": {
        "description": "A CI/CD workflow",
        "exampleFields": [
            "name",
            "status",
            "createdAt"
        ]
    },
    "Comment": {
        "description": "A version control commit comment",
        "exampleFields": [
            "body",
            "createdAt",
            "CreatedBy",
            "Mentions"
        ]
    },
    "Commit": {
        "description": "A version control commit",
        "exampleFields": [
            "message",
            "repository",
            "createdAt",
            "additions",
            "CreatedBy"
        ]
    },
    "Cost": {
        "description": "A cloud cost record",
        "exampleFields": [
            "service",
            "amortizedCost",
            "usageQuantity",
            "startTime",
            "endTime"
        ]
    },
    "CostForecast": {
        "description": "A cloud cost prediction",
        "exampleFields": [
            "service",
            "metric",
            "meanValue",
            "lowerBound",
            "upperBound"
        ]
    },
    "Customer": {
        "description": "A service desk organization",
        "exampleFields": [
            "name",
            "type",
            "contactEmail"
        ]
    },
    "Discussion": {
        "description": "A version control discussion",
        "exampleFields": [
            "title",
            "body",
            "category",
            "createdAt",
            "CreatedBy"
        ]
    },
    "DiscussionComment": {
        "description": "A version control discussion comment",
        "exampleFields": [
            "body",
            "createdAt",
            "authorName"
        ]
    },
    "Event": {
        "description": "An activity record from any system",
        "exampleFields": [
            "action",
            "occurredAt",
            "Actor",
            "Entity"
        ]
    },
    "Flow": {
        "description": "Software contributor's daily work pattern and interruptions",
        "exampleFields": [
            "focusTime",
            "disruptedTime",
            "Messages",
            "CalendarEntries",
            "VideoCalls"
        ]
    },
    "Incident": {
        "description": "A service incident",
        "exampleFields": [
            "customerImpactScope",
            "detected_at",
            "resolved_at",
            "timeToResolve",
            "publicId"
        ]
    },
    "Issue": {
        "description": "A project management issue",
        "exampleFields": [
            "status",
            "priority",
            "createdAt",
            "CurrentAssignee",
            "Epic",
            "Sprints"
        ]
    },
    "IssueComment": {
        "description": "A project management issue comment",
        "exampleFields": [
            "body",
            "CreatedBy",
            "Mentions",
            "createdAt"
        ]
    },
    "Message": {
        "description": "A team chat message",
        "exampleFields": [
            "totalUserMentions",
            "ChannelName",
            "CreatedBy",
            "Mentions",
            "Readers"
        ]
    },
    "Monitor": {
        "description": "A service monitor",
        "exampleFields": [
            "name",
            "priority",
            "state",
            "createdAt",
            "updatedAt"
        ]
    },
    "Person": {
        "description": "An user from any system",
        "exampleFields": [
            "displayName",
            "email",
            "title",
            "timezone",
            "Team"
        ]
    },
    "Project": {
        "description": "A project management project",
        "exampleFields": [
            "projectKey",
            "description",
            "lead"
        ]
    },
    "PullRequest": {
        "description": "A version control merge request",
        "exampleFields": [
            "state",
            "additions",
            "Branch",
            "CreatedBy",
            "mergedAt"
        ]
    },
    "PullRequestReview": {
        "description": "A version control review",
        "exampleFields": [
            "state",
            "submittedAt",
            "CreatedBy",
            "LeadTime",
            "MergeTime"
        ]
    },
    "PullRequestReviewComment": {
        "description": "A version control review comment",
        "exampleFields": [
            "repository",
            "PullRequest",
            "CreatedBy",
            "createdAt"
        ]
    },
    "PullRequestReviewThread": {
        "description": "A version control review thread",
        "exampleFields": [
            "path",
            "line",
            "commentCount",
            "resolved",
            "resolvedBy"
        ]
    },
    "Release": {
        "description": "A version control release",
        "exampleFields": [
            "releaseName",
            "tagName",
            "status",
            "CreatedBy",
            "createdAt"
        ]
    },
    "Repository": {
        "description": "A version control repository",
        "exampleFields": [
            "fullName",
            "description",
            "language",
            "size"
        ]
    },
    "ScanIssue": {
        "description": "A security vulnerability",
        "exampleFields": [
            "severity",
            "status",
            "Repository",
            "createdAt",
            "resolvedAt"
        ]
    },
    "ScanTarget": {
        "description": "A security scan target",
        "exampleFields": [
            "type",
            "origin",
            "tags",
            "targetFile",
            "targetReference",
            "Repository"
        ]
    },
    "Service": {
        "description": "A monitored service",
        "exampleFields": [
            "name",
            "ddTeam",
            "team",
            "status",
            "description"
        ]
    },
    "Slo": {
        "description": "A service level objective",
        "exampleFields": [
            "name",
            "targetThreshold",
            "description",
            "timeframe",
            "status"
        ]
    },
    "SourceFile": {
        "description": "A version control source file",
        "exampleFields": [
            "path",
            "repository",
            "branch",
            "size",
            "lastModified"
        ]
    },
    "Sprint": {
        "description": "A project management sprint",
        "exampleFields": [
            "name",
            "goal",
            "startDate",
            "endDate",
            "status"
        ]
    },
    "Synthetics": {
        "description": "A service synthetic test",
        "exampleFields": [
            "name",
            "status",
            "location",
            "responseTime",
            "lastRun"
        ]
    },
    "Tag": {
        "description": "A version control tag",
        "exampleFields": [
            "repository",
            "commitSha",
            "createdAt",
            "CreatedBy"
        ]
    },
    "Team": {
        "description": "A group of people",
        "exampleFields": [
            "name",
            "description",
            "createdAt"
        ]
    },
    "TimeInStatus": {
        "description": "Status duration tracking",
        "exampleFields": [
            "kind",
            "status",
            "duration",
            "entityType",
            "Parent"
        ]
    },
    "UserCallStatus": {
        "description": "A messaging user's call status",
        "exampleFields": [
            "userId",
            "status",
            "startTime",
            "duration"
        ]
    },
    "UserStatus": {
        "description": "A messaging user's status",
        "exampleFields": [
            "userId",
            "status",
            "statusText",
            "updatedAt"
        ]
    },
    "VideoCall": {
        "description": "A messaging video call",
        "exampleFields": [
            "startTime",
            "duration",
            "Attendee",
            "startedAt",
            "endedAt"
        ]
    },
    "VideoCallStatus": {
        "description": "A messaging video call state",
        "exampleFields": [
            "status",
            "participantCount",
            "startTime",
            "endTime"
        ]
    },
    "Worklog": {
        "description": "A project management time log",
        "exampleFields": [
            "Issue",
            "timeSpent",
            "startTime",
            "CreatedBy"
        ]
    }
};
export const entityAttributeDefinitions = {
    "Artifact": {
        "attributes": [
            {
                "name": "description",
                "description": "Human-readable description"
            },
            {
                "name": "kind",
                "description": "Type (e.g. container, package)"
            },
            {
                "name": "version",
                "description": "Version identifier"
            },
            {
                "name": "registry",
                "description": "Storage registry"
            },
            {
                "name": "ecosystem",
                "description": "Software ecosystem"
            },
            {
                "name": "status",
                "description": "Package status (created, published, or updated)"
            },
            {
                "name": "createdAt",
                "description": "Creation timestamp"
            },
            {
                "name": "updatedAt",
                "description": "Last update timestamp"
            }
        ]
    },
    "Board": {
        "attributes": [
            {
                "name": "type",
                "description": "Board type"
            }
        ]
    },
    "Branch": {
        "attributes": [
            {
                "name": "branch",
                "description": "Branch name"
            },
            {
                "name": "repository",
                "description": "Repository name"
            },
            {
                "name": "status",
                "description": "Branch status (created, deleted, force pushed, or updated)"
            },
            {
                "name": "createdAt",
                "description": "Creation timestamp"
            },
            {
                "name": "deletedAt",
                "description": "Deletion timestamp"
            }
        ]
    },
    "CalendarEntry": {
        "attributes": [
            {
                "name": "allDay",
                "description": "Whether the event is an all-day event"
            },
            {
                "name": "attachments",
                "description": "Number of attachments"
            },
            {
                "name": "attendeesNumber",
                "description": "Number of attendees"
            },
            {
                "name": "description",
                "description": "Event description"
            },
            {
                "name": "duration",
                "description": "Event duration in minutes"
            },
            {
                "name": "endTime",
                "description": "Event end time"
            },
            {
                "name": "startTime",
                "description": "Event start time"
            },
            {
                "name": "summary",
                "description": "Event summary/title"
            },
            {
                "name": "timezone",
                "description": "Event timezone"
            },
            {
                "name": "timeZoneOffset",
                "description": "Timezone offset in minutes"
            },
            {
                "name": "totalCostInHours",
                "description": "Total cost in person-hours (duration × attendees)"
            },
            {
                "name": "status",
                "description": "Event status (created, started)"
            },
            {
                "name": "createdAt",
                "description": "Creation timestamp"
            },
            {
                "name": "sourceUrl",
                "description": "URL to the calendar event"
            },
            {
                "name": "vzblCategories",
                "description": "Categories of the event"
            },
            {
                "name": "vzblHasAgenda",
                "description": "Whether the event has an agenda"
            },
            {
                "name": "vzblHasExternalAttendees",
                "description": "Whether the event has external attendees"
            },
            {
                "name": "vzblHasOutcome",
                "description": "Whether the event has an outcome"
            },
            {
                "name": "vzblKeywords",
                "description": "Keywords associated with the event"
            },
            {
                "name": "vzblLocationType",
                "description": "Type of location for the event"
            },
            {
                "name": "vzblQualityScore",
                "description": "Quality score of the event"
            },
            {
                "name": "vzblScope",
                "description": "Scope of the event"
            },
            {
                "name": "vzblTopics",
                "description": "Topics of the event"
            },
            {
                "name": "vzblValueStatement",
                "description": "Value statement of the event"
            },
            {
                "name": "serviceDeskOrgs",
                "description": "Service desk organizations associated with the event"
            }
        ]
    },
    "Channel": {
        "attributes": [
            {
                "name": "purpose",
                "description": "Channel's stated purpose"
            },
            {
                "name": "createdAt",
                "description": "Creation timestamp"
            }
        ]
    },
    "CicdPipeline": {
        "attributes": [
            {
                "name": "branch",
                "description": "Git branch where the build is running"
            },
            {
                "name": "repository",
                "description": "Git repository where the build is running"
            },
            {
                "name": "state",
                "description": "Build state (created, running, failed, success)"
            },
            {
                "name": "triggerType",
                "description": "What triggered the build (webhook, api, schedule)"
            },
            {
                "name": "message",
                "description": "Associated git commit message"
            },
            {
                "name": "createdAt",
                "description": "When the build started"
            }
        ]
    },
    "CicdWorkflow": {
        "attributes": []
    },
    "Comment": {
        "attributes": [
            {
                "name": "body",
                "description": "Content of the comment"
            },
            {
                "name": "commitId",
                "description": "Associated git commit identifier"
            },
            {
                "name": "createdAt",
                "description": "When the comment was created"
            },
            {
                "name": "authorName",
                "description": "Name of the person who wrote the comment"
            }
        ]
    },
    "Commit": {
        "attributes": [
            {
                "name": "message",
                "description": "Git commit message"
            },
            {
                "name": "authorName",
                "description": "Name of the person who authored the commit"
            },
            {
                "name": "repository",
                "description": "Repository where the commit exists"
            },
            {
                "name": "createdAt",
                "description": "The commit date (changes upon rebase/amend)"
            },
            {
                "name": "authoredDate",
                "description": "When the commit was authored"
            },
            {
                "name": "distinct",
                "description": "Whether this commit is distinct from others"
            },
            {
                "name": "filesAdded",
                "description": "List of files added in the commit"
            },
            {
                "name": "filesModified",
                "description": "List of files modified in the commit"
            },
            {
                "name": "filesDeleted",
                "description": "List of files deleted in the commit"
            },
            {
                "name": "totalFilesAdded",
                "description": "Number of files added"
            },
            {
                "name": "totalFilesModified",
                "description": "Number of files modified"
            },
            {
                "name": "totalFilesDeleted",
                "description": "Number of files deleted"
            },
            {
                "name": "additions",
                "description": "Number of lines added"
            },
            {
                "name": "deletions",
                "description": "Number of lines deleted"
            },
            {
                "name": "workTimeSinceLastCommit",
                "description": "Working time elapsed since the author's last commit, accounting for working hours (8h/day), weekends, and timezone."
            },
            {
                "name": "treeId",
                "description": "Git tree identifier"
            },
            {
                "name": "vzblMessageClarityScore",
                "description": "Score indicating how clear the commit message is"
            },
            {
                "name": "vzblMessageClarityExplanation",
                "description": "Explanation of the message clarity score"
            },
            {
                "name": "vzblAtomicityScore",
                "description": "Score indicating how atomic (focused on a single change) the commit is"
            },
            {
                "name": "vzblAtomicityExplanation",
                "description": "Explanation of the atomicity score"
            },
            {
                "name": "vzblLanguages",
                "description": "Programming languages affected by the commit"
            },
            {
                "name": "vzblTechStackLayers",
                "description": "Technical stack layers affected by the commit"
            },
            {
                "name": "vzblTechStackLayerExplanations",
                "description": "Explanations of affected tech stack layers"
            },
            {
                "name": "vzblSummaryChangeset",
                "description": "Summary of the changes made in the commit"
            },
            {
                "name": "vzblSummaryPurpose",
                "description": "Summary of the commit's purpose"
            },
            {
                "name": "vzblClassifications",
                "description": "Categories or types of changes made"
            },
            {
                "name": "vzblExpenseClassification",
                "description": "Classification of the commit as capex or opex"
            },
            {
                "name": "vzblRiskScore",
                "description": "Score indicating potential risk of the changes"
            },
            {
                "name": "vzblRiskExplanation",
                "description": "Explanation of the risk score"
            },
            {
                "name": "vzblTopics",
                "description": "Topics or areas affected by the commit"
            },
            {
                "name": "vzblKeywords",
                "description": "Key terms extracted from the commit"
            },
            {
                "name": "vzblComplexity",
                "description": "Score indicating the complexity of changes"
            },
            {
                "name": "vzblComplexityExplanation",
                "description": "Explanation of the complexity score"
            },
            {
                "name": "vzblMaintainability",
                "description": "Score indicating how maintainable the changes are"
            },
            {
                "name": "vzblMaintainabilityExplanation",
                "description": "Explanation of the maintainability score"
            },
            {
                "name": "vzblQuality",
                "description": "Score indicating the overall quality of the commit"
            },
            {
                "name": "vzblQualityExplanation",
                "description": "Explanation of the quality score"
            },
            {
                "name": "vzblSentimentScore",
                "description": "Score indicating the sentiment of the commit message"
            },
            {
                "name": "vzblCategory",
                "description": "Category of the commit"
            },
            {
                "name": "vzblLanguage",
                "description": "Primary language of the commit message"
            },
            {
                "name": "vzblTone",
                "description": "Tone of the commit message"
            },
            {
                "name": "vzblEmotion",
                "description": "Emotional content detected in the commit message"
            },
            {
                "name": "sourceUrl",
                "description": "URL to view the commit"
            }
        ]
    },
    "Cost": {
        "attributes": []
    },
    "CostForecast": {
        "attributes": []
    },
    "Customer": {
        "attributes": [
            {
                "name": "type",
                "description": "Type of customer (e.g., serviceDesk)"
            }
        ]
    },
    "Discussion": {
        "attributes": [
            {
                "name": "body",
                "description": "Full text content"
            },
            {
                "name": "category",
                "description": "Topic classification or grouping"
            },
            {
                "name": "createdAt",
                "description": "Creation timestamp"
            }
        ]
    },
    "DiscussionComment": {
        "attributes": []
    },
    "Event": {
        "attributes": [
            {
                "name": "Action",
                "description": "Action performed by the event"
            },
            {
                "name": "description",
                "description": "Human-readable description of what occurred"
            },
            {
                "name": "occurredAt",
                "description": "Exact timestamp when the event occurred"
            },
            {
                "name": "oldStatus",
                "description": "Previous status category (e.g., open, started, completed)"
            },
            {
                "name": "newStatus",
                "description": "Updated status category (e.g., open, started, completed)"
            },
            {
                "name": "oldStatusLabel",
                "description": "Previous custom status name (e.g., 'In QA', 'Ready to Review')"
            },
            {
                "name": "newStatusLabel",
                "description": "Updated custom status name (e.g., 'In Progress', 'Blocked')"
            },
            {
                "name": "oldStatusCategory",
                "description": "Previous status grouping (e.g., 'To Do', 'In Progress', 'Done')"
            },
            {
                "name": "newStatusCategory",
                "description": "Updated status grouping (e.g., 'To Do', 'In Progress', 'Done')"
            },
            {
                "name": "synthetic",
                "description": "Whether this event was system-generated rather than from a webhook"
            },
            {
                "name": "oldValue",
                "description": "Previous value for any changed field in JSON format"
            },
            {
                "name": "dnd_status_start",
                "description": "Start time of Slack do-not-disturb period"
            },
            {
                "name": "dnd_status_end",
                "description": "End time of Slack do-not-disturb period"
            },
            {
                "name": "duration",
                "description": "Duration in seconds (used for Slack huddles/calls)"
            },
            {
                "name": "merged",
                "description": "Whether a pull request/merge request was merged"
            },
            {
                "name": "before",
                "description": "Git commit SHA before the change"
            },
            {
                "name": "head",
                "description": "Git commit SHA after the change"
            },
            {
                "name": "reviewState",
                "description": "Pull request review state (e.g., approved, changes_requested)"
            }
        ]
    },
    "Activity": {
        "attributes": [
            {
                "name": "Action",
                "description": "Action performed by the event"
            },
            {
                "name": "description",
                "description": "Human-readable description of what occurred"
            },
            {
                "name": "occurredAt",
                "description": "Exact timestamp when the event occurred"
            }
        ]
    },
    "Flow": {
        "attributes": [
            {
                "name": "Date",
                "description": "Day for which metrics were calculated"
            },
            {
                "name": "focusTime",
                "description": "Minutes of uninterrupted work without meetings or messages"
            },
            {
                "name": "focusTimePercent",
                "description": "Percentage of working hours spent in uninterrupted work"
            },
            {
                "name": "workingTime",
                "description": "Total minutes between first and last activity of the day"
            },
            {
                "name": "meetingTime",
                "description": "Minutes spent in calendar events"
            },
            {
                "name": "messagingTime",
                "description": "Minutes spent in chat or messaging apps"
            },
            {
                "name": "videoCallTime",
                "description": "Minutes spent in video or voice calls"
            },
            {
                "name": "disruptedTime",
                "description": "Minutes of work with interruptions from meetings or messages"
            },
            {
                "name": "disruptedTimePercent",
                "description": "Percentage of working hours with interruptions"
            },
            {
                "name": "messagesCount",
                "description": "Number of messages sent or received"
            },
            {
                "name": "videoCallsCount",
                "description": "Number of video or voice calls joined"
            },
            {
                "name": "meetingsCount",
                "description": "Number of calendar events attended"
            },
            {
                "name": "dayStart",
                "description": "Timestamp of first activity"
            },
            {
                "name": "dayEnd",
                "description": "Timestamp of last activity"
            },
            {
                "name": "timezone",
                "description": "Time zone used for calculations"
            }
        ]
    },
    "Incident": {
        "attributes": []
    },
    "Issue": {
        "attributes": [
            {
                "name": "description",
                "description": "Detailed explanation with steps to reproduce and requirements"
            },
            {
                "name": "environment",
                "description": "Technical context or deployment environment"
            },
            {
                "name": "issueKey",
                "description": "Reference number in tracking system"
            },
            {
                "name": "issueType",
                "description": "Work category (Bug, Story, Task, Epic)"
            },
            {
                "name": "labels",
                "description": "Custom tags for grouping and filtering"
            },
            {
                "name": "priority",
                "description": "Standardized importance ranking"
            },
            {
                "name": "projectKey",
                "description": "Parent project identifier"
            },
            {
                "name": "status",
                "description": "Current workflow state"
            },
            {
                "name": "statusLabel",
                "description": "Custom status name (e.g., In QA, Blocked, Ready for Review)"
            },
            {
                "name": "statusCategory",
                "description": "Standard status grouping (To Do, In Progress, Done)"
            },
            {
                "name": "statusChangeDate",
                "description": "Last workflow state change"
            },
            {
                "name": "summary",
                "description": "issue summary"
            },
            {
                "name": "storyPoints",
                "description": "story points"
            },
            {
                "name": "title",
                "description": "title"
            },
            {
                "name": "serviceDeskOrgs",
                "description": "Organizations with service desk access"
            },
            {
                "name": "originalEstimate",
                "description": "original estimate"
            },
            {
                "name": "remainingEstimate",
                "description": "remaining estimate"
            },
            {
                "name": "timeSpent",
                "description": "time spent"
            },
            {
                "name": "workRatio",
                "description": "Percentage of original estimate spent (time spent / original estimate * 100)"
            },
            {
                "name": "aggregateOriginalEstimate",
                "description": "Combined initial time estimate for issue and all subtasks"
            },
            {
                "name": "aggregateTimeSpent",
                "description": "Total time logged including subtasks"
            },
            {
                "name": "aggregateRemainingEstimate",
                "description": "Total remaining time including subtasks"
            },
            {
                "name": "aggregateWorkRatio",
                "description": "Combined percentage of original estimate spent across issue and subtasks"
            },
            {
                "name": "dueDate",
                "description": "Target completion date"
            },
            {
                "name": "vzblExpenseClassification",
                "description": "Classification of the issue as capex or opex"
            },
            {
                "name": "vzblClassification",
                "description": "Categorized work type"
            },
            {
                "name": "vzblClassificationExplanation",
                "description": "Explanation of work type categorization"
            },
            {
                "name": "vzblCycleTime",
                "description": "Active development time"
            },
            {
                "name": "vzblClockCycleTime",
                "description": "Calendar time (only including business hours) in active development"
            },
            {
                "name": "vzblFrictionScore",
                "description": "Workflow impediment rating"
            },
            {
                "name": "vzblFrictionExplanation",
                "description": "Details about workflow impediments"
            },
            {
                "name": "vzblHasOpenQuestions",
                "description": "Whether clarification is needed"
            },
            {
                "name": "vzblImpact",
                "description": "assessedimpact"
            },
            {
                "name": "vzblImpactExplanation",
                "description": "explanation for assessed impact"
            },
            {
                "name": "vzblKeywords",
                "description": "Extracted key terms"
            },
            {
                "name": "vzblLeadTime",
                "description": "Total lifecycle time"
            },
            {
                "name": "vzblClockLeadTime",
                "description": "Total lifecycle time (only including business hours)"
            },
            {
                "name": "vzblMissingDetails",
                "description": "Required information identified as absent"
            },
            {
                "name": "vzblClarityScore",
                "description": "clarity score"
            },
            {
                "name": "vzblClarityExplanation",
                "description": "clarity score explanation"
            },
            {
                "name": "vzblSummary",
                "description": "Automated brief"
            },
            {
                "name": "vzblTopics",
                "description": "Extracted topics"
            },
            {
                "name": "vzblUnansweredQuestions",
                "description": "Open queries needing response"
            },
            {
                "name": "vzblTotalQuestions",
                "description": "Count of identified queries"
            },
            {
                "name": "vzblUrgency",
                "description": "expressed urgency"
            },
            {
                "name": "vzblUrgencyExplanation",
                "description": "Explanation for expressed urgency"
            },
            {
                "name": "vzblValueStatement",
                "description": "Business value summary"
            },
            {
                "name": "startedAt",
                "description": "Work begin time"
            },
            {
                "name": "completedAt",
                "description": "Work finish time"
            },
            {
                "name": "closedAt",
                "description": "Final resolution time"
            },
            {
                "name": "updatedAt",
                "description": "Last modification time"
            },
            {
                "name": "createdAt",
                "description": "Initial creation time"
            },
            {
                "name": "comments",
                "description": "Number of discussion posts"
            },
            {
                "name": "stateReason",
                "description": "Explanation for current state"
            },
            {
                "name": "repository",
                "description": "Associated code repository"
            }
        ]
    },
    "IssueComment": {
        "attributes": [
            {
                "name": "body",
                "description": "Text content of the comment"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            },
            {
                "name": "updatedAt",
                "description": "Last modification time"
            },
            {
                "name": "vzblCategory",
                "description": "Content type (user feedback, technical feedback, contextual info, question, recommendation, action)"
            },
            {
                "name": "vzblEmotion",
                "description": "Emotional tone (happy, sad, angry, excited, neutral)"
            },
            {
                "name": "vzblKeywords",
                "description": "Key terms extracted from content"
            },
            {
                "name": "vzblLanguage",
                "description": "Primary language used"
            },
            {
                "name": "vzblSentimentScore",
                "description": "Numerical rating of emotional sentiment"
            },
            {
                "name": "vzblTone",
                "description": "Writing style (formal, informal, informative, sarcastic, aggressive, objective, inquisitive, empathetic, critical, appreciative)"
            },
            {
                "name": "vzblTopics",
                "description": "Subject areas discussed"
            },
            {
                "name": "issueUrl",
                "description": "Link to parent issue"
            }
        ]
    },
    "Monitor": {
        "attributes": [
            {
                "name": "priority",
                "description": "Alert importance level"
            },
            {
                "name": "createdAt",
                "description": "Initial creation time"
            },
            {
                "name": "updatedAt",
                "description": "Last modification time"
            }
        ]
    },
    "Message": {
        "attributes": [
            {
                "name": "event_ts",
                "description": "Timestamp of when the message event occurred"
            },
            {
                "name": "size",
                "description": "Length of the message content in characters"
            },
            {
                "name": "totalUserMentions",
                "description": "Number of user mentions in the message"
            },
            {
                "name": "totalIssuesReferenced",
                "description": "Number of issue references in the message"
            },
            {
                "name": "subtype",
                "description": "Message subtype indicating special message formats or behaviors"
            },
            {
                "name": "vzblCategory",
                "description": "Content type classification of the message"
            },
            {
                "name": "vzblEmotion",
                "description": "Detected emotional content of the message"
            },
            {
                "name": "vzblKeywords",
                "description": "Key terms automatically extracted from the message"
            },
            {
                "name": "vzblLanguage",
                "description": "Primary language used in the message"
            },
            {
                "name": "vzblSentimentScore",
                "description": "Numerical score indicating the emotional tone (-5 to 5)"
            },
            {
                "name": "vzblTone",
                "description": "Writing style and tone of the message"
            },
            {
                "name": "vzblTopics",
                "description": "Subject areas discussed in the message"
            },
            {
                "name": "vzblReadTime",
                "description": "Estimated time in seconds to read the message"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "Person": {
        "attributes": [
            {
                "name": "avatarUrl",
                "description": "Profile picture URL"
            },
            {
                "name": "email",
                "description": "Primary email address"
            },
            {
                "name": "emailDomain",
                "description": "Organization domain from email"
            },
            {
                "name": "login",
                "description": "Username for authentication"
            },
            {
                "name": "userType",
                "description": "Account classification (User, Bot, Organization)"
            },
            {
                "name": "timezone",
                "description": "Local time zone"
            },
            {
                "name": "userName",
                "description": "Display handle"
            },
            {
                "name": "phone",
                "description": "Contact number"
            },
            {
                "name": "userId",
                "description": "Internal identifier"
            },
            {
                "name": "url",
                "description": "API endpoint URL"
            },
            {
                "name": "teamId",
                "description": "Associated team identifier"
            },
            {
                "name": "title",
                "description": "Professional role or position"
            },
            {
                "name": "handle",
                "description": "Service-specific username"
            },
            {
                "name": "displayName",
                "description": "Full visible name"
            },
            {
                "name": "isBot",
                "description": "Whether account is automated"
            },
            {
                "name": "deleted",
                "description": "Whether account is deactivated"
            }
        ]
    },
    "Project": {
        "attributes": [
            {
                "name": "projectKey",
                "description": "Unique key identifier for the project"
            },
            {
                "name": "projectTypeKey",
                "description": "Type of project (e.g. software, service_desk)"
            }
        ]
    },
    "Service": {
        "attributes": [
            {
                "name": "ddTeam",
                "description": "The Datadog team associated with the service"
            },
            {
                "name": "team",
                "description": "The team responsible for the service"
            }
        ]
    },
    "Slo": {
        "attributes": [
            {
                "name": "targetThreshold",
                "description": "The target service level objective threshold value"
            }
        ]
    },
    "TimeInStatus": {
        "attributes": [
            {
                "name": "kind",
                "description": "The categorization method used for tracking time in status (e.g. statusLabel, statusCategory)"
            },
            {
                "name": "status",
                "description": "The specific workflow state being measured (e.g. To Do, In Progress, Done)"
            },
            {
                "name": "duration",
                "description": "Duration spent in the current status"
            }
        ]
    },
    "Tag": {
        "attributes": [
            {
                "name": "repository",
                "description": "Name of the repository where the tag exists"
            },
            {
                "name": "status",
                "description": "Lifecycle state of the tag (e.g. created, deleted) indicating its current state in version control"
            }
        ]
    },
    "PullRequest": {
        "attributes": [
            {
                "name": "additions",
                "description": "Number of lines added in the changes"
            },
            {
                "name": "base",
                "description": "Target branch for the changes"
            },
            {
                "name": "body",
                "description": "Full description of the proposed changes"
            },
            {
                "name": "branch",
                "description": "Source branch containing the changes"
            },
            {
                "name": "closedAt",
                "description": "When the pull request was closed"
            },
            {
                "name": "commits",
                "description": "Number of commits included"
            },
            {
                "name": "cycleTime",
                "description": "Time between pull request creation and merge (null if not merged)"
            },
            {
                "name": "pickupTime",
                "description": "Time between creation and first review activity"
            },
            {
                "name": "clockPickupTime",
                "description": "Time (only including business hours) between creation and first review activity"
            },
            {
                "name": "reviewTime",
                "description": "Time between first review activity (pickupDate) and last submitted review (reviewDate), where pickupDate is the time of first review comment and reviewDate is the timestamp of the most recent review submission"
            },
            {
                "name": "clockReviewTime",
                "description": "Time (only including business hours) between first review activity (pickupDate) and last submitted review (reviewDate), where pickupDate is the time of first review comment and reviewDate is the timestamp of the most recent review submission"
            },
            {
                "name": "mergeTime",
                "description": "Time between review approval and merge"
            },
            {
                "name": "clockMergeTime",
                "description": "Time (only including business hours) between review approval and merge"
            },
            {
                "name": "commitLeadTime",
                "description": "Time between pull request merge and first commit"
            },
            {
                "name": "clockCommitLeadTime",
                "description": "Time (only including business hours) between pull request merge and first commit"
            },
            {
                "name": "deletions",
                "description": "Number of lines removed in the changes"
            },
            {
                "name": "head",
                "description": "Source branch reference"
            },
            {
                "name": "labels",
                "description": "List of labels applied to the pull request"
            },
            {
                "name": "merged",
                "description": "Whether the changes were merged"
            },
            {
                "name": "mergedAt",
                "description": "When the changes were merged"
            },
            {
                "name": "number",
                "description": "Pull request identifier in the repository"
            },
            {
                "name": "totalComments",
                "description": "Total number of comments including reviews and discussions"
            },
            {
                "name": "vzblClassifications",
                "description": "Automated categorization of changes (e.g. feature, defect, configuration, chore, documentation, testing) based on code analysis"
            },
            {
                "name": "vzblExpenseClassification",
                "description": "Classification of the pull request as capex or opex"
            },
            {
                "name": "vzblComplexity",
                "description": "Numerical score (0-10) indicating change complexity based on code analysis, with higher values indicating more complex changes"
            },
            {
                "name": "vzblComplexityExplanation",
                "description": "Detailed explanation of factors contributing to the complexity score"
            },
            {
                "name": "vzblConfidenceScore",
                "description": "Confidence level (0-1) in the automated analysis results"
            },
            {
                "name": "vzblHasOpenQuestions",
                "description": "Boolean flag indicating presence of unresolved questions in review discussions"
            },
            {
                "name": "vzblKeywords",
                "description": "Array of significant terms automatically extracted from code changes and discussions"
            },
            {
                "name": "vzblMaintainability",
                "description": "Numerical score (0-10) assessing code maintainability, considering factors like modularity and documentation"
            },
            {
                "name": "vzblMaintainabilityExplanation",
                "description": "Detailed explanation of factors affecting the maintainability score"
            },
            {
                "name": "vzblRiskScore",
                "description": "Numerical score (0-10) assessing potential risk of changes based on scope, complexity, and test coverage"
            },
            {
                "name": "vzblRiskExplanation",
                "description": "Detailed explanation of factors contributing to the risk assessment"
            },
            {
                "name": "vzblSummaryPurpose",
                "description": "concise explanation of the change's intended purpose and motivation"
            },
            {
                "name": "vzblSummaryChangeset",
                "description": "technical summary of the actual code changes and their impact"
            },
            {
                "name": "vzblQuality",
                "description": "Numerical score (0-10) evaluating overall code quality based on multiple metrics including complexity, maintainability, and test coverage"
            },
            {
                "name": "vzblQualityExplanation",
                "description": "Detailed explanation of factors contributing to the quality score"
            },
            {
                "name": "vzblTopics",
                "description": "Array of technical domains and subject areas affected by the changes"
            },
            {
                "name": "vzblUnansweredQuestions",
                "description": "Array of identified questions in discussions that still need responses"
            },
            {
                "name": "state",
                "description": "Current state (open, closed, merged)"
            },
            {
                "name": "title",
                "description": "Summary of the proposed changes"
            },
            {
                "name": "createdAt",
                "description": "When the pull request was created"
            },
            {
                "name": "status",
                "description": "Processing status (draft, open, merged, closed)"
            },
            {
                "name": "updatedAt",
                "description": "When the pull request was last modified"
            }
        ]
    },
    "PullRequestReview": {
        "attributes": [
            {
                "name": "body",
                "description": "Text content of the review feedback"
            },
            {
                "name": "state",
                "description": "Review decision (approved, changes_requested, commented, or dismissed)"
            },
            {
                "name": "submittedAt",
                "description": "Timestamp when feedback was submitted"
            },
            {
                "name": "repository",
                "description": "Full name of the repository containing the reviewed code"
            },
            {
                "name": "pullRequestTitle",
                "description": "Title of the associated pull request"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "PullRequestReviewComment": {
        "attributes": [
            {
                "name": "body",
                "description": "Text content of the review comment"
            },
            {
                "name": "commitId",
                "description": "Git commit id that the comment is associated with"
            },
            {
                "name": "pullRequestReviewId",
                "description": "Identifier of the parent pull request review"
            },
            {
                "name": "authorName",
                "description": "Username of the person who wrote the comment"
            },
            {
                "name": "repository",
                "description": "Repository where the comment was made"
            },
            {
                "name": "pullRequestTitle",
                "description": "Title of the pull request being reviewed"
            },
            {
                "name": "pullRequestAuthorName",
                "description": "Username of the pull request author"
            },
            {
                "name": "vzblCategory",
                "description": "Content type (technical feedback, contextual info, question, recommendation, action)"
            },
            {
                "name": "vzblEmotion",
                "description": "Emotional tone (happy, sad, angry, excited, neutral)"
            },
            {
                "name": "vzblKeywords",
                "description": "Key terms extracted from content"
            },
            {
                "name": "vzblLanguage",
                "description": "Primary language used in the comment"
            },
            {
                "name": "vzblTone",
                "description": "Writing style (formal, informal, informative, sarcastic, aggressive, objective, inquisitive, empathetic, critical, appreciative)"
            },
            {
                "name": "vzblTopics",
                "description": "Subject areas discussed in the comment"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "Repository": {
        "attributes": [
            {
                "name": "archived",
                "description": "Whether the repository has been archived and is read-only"
            },
            {
                "name": "description",
                "description": "Human-readable explanation of the repository's purpose and contents"
            },
            {
                "name": "disabled",
                "description": "Whether the repository has been administratively disabled"
            },
            {
                "name": "fullName",
                "description": "Complete repository identifier including organization (e.g. 'org/repo')"
            },
            {
                "name": "orgName",
                "description": "Name of the owning organization"
            },
            {
                "name": "hasIssues",
                "description": "Whether issue tracking is enabled for the repository"
            },
            {
                "name": "language",
                "description": "Primary programming language used in the codebase"
            },
            {
                "name": "openIssuesCount",
                "description": "Number of currently open issues and pull requests"
            },
            {
                "name": "private",
                "description": "Whether the repository is only accessible to authorized users"
            },
            {
                "name": "size",
                "description": "Repository size in kilobytes"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            },
            {
                "name": "updatedAt",
                "description": "Last modification time"
            }
        ]
    },
    "Release": {
        "attributes": [
            {
                "name": "body",
                "description": "Detailed release notes and documentation"
            },
            {
                "name": "draft",
                "description": "Whether this is an unpublished draft release"
            },
            {
                "name": "preRelease",
                "description": "Whether this is a pre-release version"
            },
            {
                "name": "repository",
                "description": "Full name of the repository where released"
            },
            {
                "name": "releaseName",
                "description": "Human-readable title"
            },
            {
                "name": "tagName",
                "description": "Git tag associated with the release"
            },
            {
                "name": "status",
                "description": "Current state (draft, published)"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "ScanTarget": {
        "attributes": [
            {
                "name": "type",
                "description": "Type of scan target (e.g. maven, npm)"
            },
            {
                "name": "origin",
                "description": "Source platform where the target is hosted"
            },
            {
                "name": "tags",
                "description": "List of labels associated with the target"
            },
            {
                "name": "targetFile",
                "description": "Path to the scanned configuration file"
            },
            {
                "name": "targetReference",
                "description": "Version or reference point for the scan"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "ScanIssue": {
        "attributes": [
            {
                "name": "description",
                "description": "Detailed explanation of the security vulnerability"
            },
            {
                "name": "type",
                "description": "Category of the security issue"
            },
            {
                "name": "fixable",
                "description": "Whether an automated fix is available"
            },
            {
                "name": "severity",
                "description": "Impact level of the vulnerability"
            },
            {
                "name": "ignored",
                "description": "Whether the issue has been marked as ignored"
            },
            {
                "name": "resolvedAt",
                "description": "When the issue was fixed"
            },
            {
                "name": "resolution",
                "description": "How the issue was resolved"
            },
            {
                "name": "resolutionDetails",
                "description": "Additional information about the resolution"
            },
            {
                "name": "locations",
                "description": "File paths or code locations affected"
            },
            {
                "name": "score",
                "description": "Numerical severity rating"
            },
            {
                "name": "status",
                "description": "Current state of the issue"
            },
            {
                "name": "updatedAt",
                "description": "Last modification time"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "Worklog": {
        "attributes": [
            {
                "name": "timeSpent",
                "description": "Duration of work logged in seconds"
            },
            {
                "name": "createdAt",
                "description": "Creation time"
            }
        ]
    },
    "VideoCall": {
        "attributes": [
            {
                "name": "startedAt",
                "description": "Start time"
            },
            {
                "name": "endedAt",
                "description": "End time"
            },
            {
                "name": "duration",
                "description": "Duration of the call in seconds"
            }
        ]
    }
};
export const entityFacetDefinitions = {
    "Activity": {
        "facets": [
            {
                "name": "Action",
                "description": "The action performed."
            },
            {
                "name": "Actor",
                "description": "The person who performed the activity."
            },
            {
                "name": "Team",
                "description": "The team(s) that the actor belongs to."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the activity occurred."
            },
            {
                "name": "Day",
                "description": "the calendar day (year/month/day)"
            },
            {
                "name": "Week",
                "description": "the calendar week (year/week)"
            },
            {
                "name": "Month",
                "description": "the calendar month (year/month)"
            },
            {
                "name": "Quarter",
                "description": "the calendar quarter (year/quarter)"
            },
            {
                "name": "Year",
                "description": "the calendar year"
            },
            {
                "name": "Minute",
                "description": "the minute (rounded down to the nearest minute)"
            },
            {
                "name": "Hour",
                "description": "the hour (rounded down to the nearest hour)"
            },
            {
                "name": "DayTrunc",
                "description": "the day (rounded down to the nearest day)"
            },
            {
                "name": "DayOfMonth",
                "description": "the day of the month (1-31)"
            },
            {
                "name": "DayOfWeek",
                "description": "the day of the week (1-7)"
            },
            {
                "name": "MonthOfYear",
                "description": "the month of the year (1-12)"
            },
            {
                "name": "QuarterOfYear",
                "description": "the quarter of the year (1-4)"
            }
        ]
    },
    "Issue": {
        "facets": [
            {
                "name": "CurrentReporter",
                "description": "The person currently assigned as the reporter of the issue."
            },
            {
                "name": "CurrentAssignee",
                "description": "The person currently assigned to work on the issue."
            },
            {
                "name": "CurrentAssignee.Team",
                "description": "The team(s) that the current assignee belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who originally created the issue."
            },
            {
                "name": "CurrentSprints",
                "description": "The active sprint(s) that this issue currently belongs to."
            },
            {
                "name": "Sprints",
                "description": "Historical record of all sprints this issue has ever belonged to."
            },
            {
                "name": "Assignees",
                "description": "Historical record of all people who have ever been assigned to this issue."
            },
            {
                "name": "Assignees.Team",
                "description": "The teams associated with all historical assignees of this issue."
            },
            {
                "name": "Mentions",
                "description": "People who have been mentioned or referenced in the issue."
            },
            {
                "name": "Reporters",
                "description": "Historical record of all people who have ever been reporters of this issue."
            },
            {
                "name": "ParentIssue",
                "description": "The issue that this issue is a subtask or child of."
            },
            {
                "name": "Epic",
                "description": "The epic that this issue belongs to."
            },
            {
                "name": "Epic.status",
                "description": "The current status of the epic this issue belongs to."
            },
            {
                "name": "Epic.title",
                "description": "The title of the epic this issue belongs to."
            },
            {
                "name": "EpicTitle",
                "description": "The title of the epic this issue belongs to."
            },
            {
                "name": "Epic.statusLabel",
                "description": "The custom status label of the epic this issue belongs to."
            },
            {
                "name": "Epic.statusCategory",
                "description": "The status category (e.g., To Do, In Progress, Done) of the epic this issue belongs to."
            },
            {
                "name": "Epic.dueDate",
                "description": "The due date of the epic this issue belongs to."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the issue was created."
            },
            {
                "name": "ResolutionTime",
                "description": "The time taken to resolve the issue, measured from creation to completion."
            }
        ]
    },
    "IssueComment": {
        "facets": [
            {
                "name": "ParentName",
                "description": "The issue that this comment belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who wrote the comment."
            },
            {
                "name": "Mentions",
                "description": "People who are mentioned in the comment."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the comment was created."
            }
        ]
    },
    "Commit": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this commit belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who authored the commit."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the commit was created."
            }
        ]
    },
    "Tag": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this tag belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who created the tag."
            }
        ]
    },
    "Discussion": {
        "facets": [
            {
                "name": "CreatedBy",
                "description": "The person who created the discussion."
            }
        ]
    },
    "PullRequestReviewComment": {
        "facets": [
            {
                "name": "PullRequest",
                "description": "The pull request that this review comment belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who wrote the review comment."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the review comment was created."
            }
        ]
    },
    "PullRequest": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this pull request belongs to."
            },
            {
                "name": "Branch",
                "description": "The source branch containing the changes for this pull request."
            },
            {
                "name": "CreatedBy",
                "description": "The person who created the pull request."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the pull request was created."
            }
        ]
    },
    "PullRequestReview": {
        "facets": [
            {
                "name": "PullRequest",
                "description": "The pull request that this review belongs to."
            },
            {
                "name": "PullRequestCreatedAt",
                "description": "When the pull request being reviewed was created."
            },
            {
                "name": "PullRequestMergedAt",
                "description": "When the pull request being reviewed was merged."
            },
            {
                "name": "MergeTime",
                "description": "The time taken to merge the pull request after this review."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the review was created."
            },
            {
                "name": "LeadTime",
                "description": "The total time taken from pull request creation to review submission."
            },
            {
                "name": "CreatedBy",
                "description": "The person who performed the review."
            }
        ]
    },
    "Branch": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this branch belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who created the branch."
            },
            {
                "name": "MergedTo",
                "description": "The branches that this branch has been merged into."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the branch was created."
            }
        ]
    },
    "Comment": {
        "facets": [
            {
                "name": "ParentName",
                "description": "The commit that this comment belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who wrote the comment."
            },
            {
                "name": "Mentions",
                "description": "People who are mentioned in the comment."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the comment was created."
            }
        ]
    },
    "Release": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this release belongs to."
            },
            {
                "name": "CreatedBy",
                "description": "The person who created the release."
            },
            {
                "name": "PublishedBy",
                "description": "The person who published the release."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the release was created."
            }
        ]
    },
    "CicdPipeline": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this pipeline belongs to."
            },
            {
                "name": "Commit",
                "description": "The commit that triggered this pipeline."
            },
            {
                "name": "Branch",
                "description": "The branch that this pipeline is running on."
            },
            {
                "name": "CreatedBy",
                "description": "The person who triggered the pipeline."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the pipeline was created."
            }
        ]
    },
    "CalendarEntry": {
        "facets": [
            {
                "name": "Age",
                "description": "The time elapsed since the calendar entry was created."
            }
        ]
    },
    "Channel": {
        "facets": [
            {
                "name": "Team",
                "description": "The team that this channel belongs to."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the channel was created."
            }
        ]
    },
    "Message": {
        "facets": [
            {
                "name": "ChannelName",
                "description": "The channel where this message was posted."
            },
            {
                "name": "TeamName",
                "description": "The team associated with the channel where this message was posted."
            },
            {
                "name": "CreatedBy",
                "description": "The person who wrote the message."
            },
            {
                "name": "Mentions",
                "description": "People who are mentioned in the message."
            },
            {
                "name": "Readers",
                "description": "People who have read this message."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the message was created."
            }
        ]
    },
    "VideoCall": {
        "facets": [
            {
                "name": "Attendee",
                "description": "The people who participated in this video call."
            }
        ]
    },
    "Person": {
        "facets": [
            {
                "name": "Team",
                "description": "The teams that this person belongs to."
            }
        ]
    },
    "Event": {
        "facets": [
            {
                "name": "Actor",
                "description": "The person who triggered or performed this event."
            },
            {
                "name": "Team",
                "description": "The teams associated with this event."
            },
            {
                "name": "EntityType",
                "description": "The type of entity this event is related to."
            },
            {
                "name": "Entity",
                "description": "The specific entity this event is about."
            },
            {
                "name": "Age",
                "description": "The time elapsed since the event occurred."
            },
            {
                "name": "Day",
                "description": "the calendar day (year/month/day)"
            },
            {
                "name": "Week",
                "description": "the calendar week (year/week)"
            },
            {
                "name": "Month",
                "description": "the calendar month (year/month)"
            },
            {
                "name": "Quarter",
                "description": "the calendar quarter (year/quarter)"
            },
            {
                "name": "Year",
                "description": "the calendar year"
            },
            {
                "name": "Minute",
                "description": "the minute (rounded down to the nearest minute)"
            },
            {
                "name": "Hour",
                "description": "the hour (rounded down to the nearest hour)"
            },
            {
                "name": "DayTrunc",
                "description": "the day (rounded down to the nearest day)"
            },
            {
                "name": "DayOfMonth",
                "description": "the day of the month (1-31)"
            },
            {
                "name": "DayOfWeek",
                "description": "the day of the week (1-7)"
            },
            {
                "name": "MonthOfYear",
                "description": "the month of the year (1-12)"
            },
            {
                "name": "QuarterOfYear",
                "description": "the quarter of the year (1-4)"
            }
        ]
    },
    "Flow": {
        "facets": [
            {
                "name": "Person",
                "description": "The person whose flow data this represents."
            },
            {
                "name": "Team",
                "description": "The teams that this person belongs to."
            },
            {
                "name": "Messages",
                "description": "The messages associated with this flow period."
            },
            {
                "name": "CalendarEntries",
                "description": "The calendar entries during this flow period."
            },
            {
                "name": "VideoCalls",
                "description": "The video calls that occurred during this flow period."
            }
        ]
    },
    "Artifact": {
        "facets": [
            {
                "name": "Age",
                "description": "The time elapsed since the artifact was created."
            }
        ]
    },
    "TimeInStatus": {
        "facets": [
            {
                "name": "Parent",
                "description": "The issue/ticket."
            }
        ]
    },
    "Worklog": {
        "facets": [
            {
                "name": "CreatedBy",
                "description": "The person who created this worklog entry."
            },
            {
                "name": "Issue",
                "description": "The issue this worklog entry belongs to."
            }
        ]
    },
    "ScanTarget": {
        "facets": [
            {
                "name": "Repository",
                "description": "The repository that this scan target belongs to."
            }
        ]
    },
    "ScanIssue": {
        "facets": [
            {
                "name": "ScanTarget",
                "description": "The scan target that identified this issue."
            },
            {
                "name": "Repository",
                "description": "The repository where this scan issue was found."
            }
        ]
    }
};
